require('./command.js');

PegasusTemplate.DeleteBlockCommand = PegasusTemplate.Command.extend({
  klass: null,
  backup: null,
  callback: null,
  parent: null,
  childPosition: null,
  descriptionClass: 'deleted',
  description: function(){
    return Em.I18n.t('command_descriptions.deleted_content');
  }.property(),
  execute: function() {
    var parent = PegasusTemplate.blockRegionInstance,
      rowToReplace = parent.objectAt( this.get('childPosition') ),
      element = this.get('klass').create({
        container: parent.container,
        sourceElement: this.get('sourceElement')
      }),
      callback = this.get('callback');

    parent.removeObject( rowToReplace );
    parent.insertAt( this.get('childPosition'), element );

    if ( callback ) {
      callback();
    }

    this._super();
  },

  unexecute: function(callback){
    var parent = PegasusTemplate.blockRegionInstance,
      rowToReplace = parent.objectAt( this.get('childPosition') ),
      reborn = this.get('klass').create({
        container: parent.container,
        sourceElement: this.get('backup')
      });

    parent.removeObject( rowToReplace );

    parent.insertAt( this.get('childPosition'), reborn );

    this._super();
  }
});
